<form (ngSubmit)="save()" [formGroup]="editForm" class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">Edit contract</h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group m-b-2 required">
            <label for="pricePerHour">Price per hour</label>
            <input type="number" id="pricePerHour" formControlName="pricePerHour" />
            <small>If AI finds a day rate, it is converted to hourly rate by dividing by 8.</small>
        </div>
        <div class="form-group m-b-2">
            <label for="budget">Budget (€)</label>
            <input type="number" id="budget" formControlName="budget" step="0.01" min="0" />
        </div>
        <div class="form-group m-b-2 required">
            <label for="effectiveFrom">Effective from (date)</label>
            <input type="date" id="effectiveFrom" formControlName="effectiveFrom" />
        </div>
        <div class="form-group m-b-2">
            <label for="effectiveTo">Effective to (date)</label>
            <input type="date" id="effectiveTo" formControlName="effectiveTo" />
        </div>
        <div class="form-group m-b-2">
            <label for="contractFile">Contract (replace or add)</label>
            <app-file-upload formControlName="contractFile" type="file"></app-file-upload>
            <button
                type="button"
                class="button button--icon m-t-1"
                [disabled]="aiExtracting"
                (click)="extractInvoiceFieldsWithAi()">
                <i class="las la-magic" aria-hidden="true"></i>
                <span>{{ aiExtracting ? 'Extracting…' : 'AI extract invoice fields' }}</span>
            </button>
            <div *ngIf="linkedEmployee.hasClientContract && linkedEmployee.clientContractUrl">
                <a [href]="linkedEmployee.clientContractUrl" target="_blank" style="margin-top:8px;display:inline-block;">
                    <i class="las la-paperclip"></i> View current contract
                </a>
            </div>
        </div>
        <div class="form-group m-b-2">
            <label for="poNumber">Purchase order (PO)</label>
            <input type="text" id="poNumber" formControlName="poNumber" />
        </div>
        <div class="form-group m-b-2">
            <label for="sesNumber">SES / invoicing approval</label>
            <input type="text" id="sesNumber" formControlName="sesNumber" />
        </div>
        <div class="form-group m-b-2">
            <label for="contractAgreementNumber">Contract / MSA number</label>
            <input type="text" id="contractAgreementNumber" formControlName="contractAgreementNumber" />
        </div>
        <div class="form-group m-b-2">
            <label for="freeText">Invoice free text</label>
            <textarea id="freeText" rows="3" formControlName="freeText"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <input class="button" [ngClass]="editForm.invalid ? 'button--disabled' : 'button--primary'" type="submit" value="Save" [disabled]="editForm.invalid" />
        <button class="button button--outline" (click)="activeModal.dismiss()">Cancel</button>
    </div>
</form>
